import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";

import ProfileList from "../profile/list";
import { TicketPage } from "../ticket/page";
import BlockDetails from "./block-details";
import TicketDetails from "../ticket/details";
import EstateDetails from "../estate/details";
import { BlockBilling as BlockBillingPage } from "../billing/block-billing";
import { SurveyForm } from "./voting/survey-form";
import { SurveyResults } from "./voting/results";
import { VotePage } from "./voting/vote-page";

import { routes } from "../../routes";
import { GlobalSettingsCheck } from "../common/global-settings-check";
import { clearSelectedBlock, selectBlock } from "../../redux/modules/blocks";
import { BlockEstateList } from "../estate/list";
import { Loader } from "semantic-ui-react";
import { fetchEstateCustomers } from "../../redux/modules/estate-customers";
import { fetchBoardPosts } from "../../redux/modules/board-post";
import { fetchProfiles } from "../../redux/modules/profile";
import { fetchFiles } from "../../redux/modules/file";
import { fetchBillingSummary } from "../../redux/modules/billing-summary";
import { listMonthlyReports } from "../../redux/modules/billing-monthly-report";
import { getById } from "../../redux/restdux/utils";

const Container = ({ blockId, block, blockExists, selectBlock }) => {
  const shouldReload = () => {
    if (!blockExists) {
      return false;
    }
    return !block || block.id !== blockId;
  };

  useEffect(() => {
    if (shouldReload()) {
      selectBlock(blockId);
    }
  }, []); // Initial load

  useEffect(() => {
    selectBlock(blockId);
  }, [blockId, selectBlock]);

  if (shouldReload()) {
    return <Loader active={true} />;
  }

  if (!blockExists) {
    return <div></div>;
  }

  return (
    <Switch>
      <Route exact={true} path={routes.blockDetails} component={BlockDetails} />
      <Route path={routes.blockProfiles} component={ProfileList} />
      <Route path={routes.blockEstateList} component={BlockEstateList} />
      <Route path={routes.estateDetails} component={EstateDetails} />
      <Route path={routes.blockBilling} component={BlockBillingPage} />
      <Route path={routes.blockTickets} component={TicketPage} />
      <Route path={routes.ticketDetails} component={TicketDetails} />
      <GlobalSettingsCheck check={(s) => s.features?.survey}>
        <Route path={routes.blockSurveyNew} component={SurveyForm} />
        <Route path={routes.blockSurveyEdit} component={SurveyForm} />
        <Route path={routes.blockSurveyResults} component={SurveyResults} />
        <Route path={routes.blockSurveyVote} component={VotePage} />
      </GlobalSettingsCheck>
    </Switch>
  );
};

const ConnectedContainer = withRouter(
  connect(
    (state, passedProps) => {
      const blockId = parseInt(passedProps.match.params.blockId);
      const blockList = state.blocks.entities || [];
      return {
        blockId: blockId,
        block: state.blocks.selected,
        blockExists: getById(blockId, blockList) !== undefined,
      };
    },
    (dispatch) => {
      const selectBlockWithDeps = (blockId) => (dispatch) => {
        return Promise.all(
          [
            clearSelectedBlock(blockId),
            fetchEstateCustomers(blockId),
            fetchBoardPosts(blockId),
            fetchProfiles(blockId),
            fetchFiles(blockId),
            fetchBillingSummary(blockId),
            listMonthlyReports(blockId),
          ].map(dispatch)
        ).then(() => dispatch(selectBlock(blockId)));
      };

      return bindActionCreators({ selectBlock: selectBlockWithDeps }, dispatch);
    }
  )(Container)
);

export default ConnectedContainer;
